var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-page',{attrs:{"columns":_vm.columns,"headers":_vm.headers,"popup-component":_vm.popupComponent,"show-add-button":false,"title":"User List","icon":"mdi-account-multiple","stateendpoint":"users","actions":_vm.actions,"show-default-action-buttons":false,"action-buttons":_vm.actionButtons}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }